module.exports = __webpack_public_path__ + "img/transfers_avatar.d5063801.svg";